import { z } from 'zod'

/** 航班資訊 */
export const flightInformationSchema = z.object({
  /** 航空公司 */
  airline: z.string(),
  /** 班機號碼 */
  flightNumber: z.string()
})

export interface FlightInformation
  extends z.infer<typeof flightInformationSchema> {}
